<template>
  <div class="card-item" :class="currentBirthdayClass">
    <img
      :src="image !== '' ? image : '/static/images/avatar-2.jpg'"
      class="avatar"
    />
    <div class="mt-20 details">
      <el-link
        v-if="link"
        type="primary"
        @click="emitOpenDrawer"
        class="name"
        >{{ name }}</el-link
      >
      <p v-else class="name">{{ name }}</p>

      <p class="formattedDate">{{ formattedDate }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BirthdayItem",
  emits: ["open-drawer"],
  props: {
    name: {
      type: String
    },
    image: {
      type: String
    },
    formattedDate: {
      type: String
    },
    date: {
      type: String
    },
    id: {
      type: Number
    },
    link: {
      type: Boolean
    }
  },
  methods: {
    emitOpenDrawer() {
      this.$emit("open-drawer", this.id, this.formattedDate);
    }
  },
  computed: {
    currentBirthdayClass() {
      const currentDate = new Date();
      let employeeBirthday;

      if (this.date) {
        employeeBirthday = new Date(this.date);

        if (
          employeeBirthday.getDate() == currentDate.getDate() &&
          employeeBirthday.getMonth() == currentDate.getMonth()
        ) {
          return { "bg-warning-light": true };
        }
      }
      return { "bg-warning-light": false };
    }
  }
};
</script>

<style lang="scss" scoped>
.card-item {
  height: 60px;
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  align-self: flex-start;
  margin: 10px 0px 10px 0;

  .name {
    font-size: 110%;
    font-weight: 700 !important;
    margin: 0;
  }

  .details {
    padding-left: 16px;
  }

  .formattedDate {
    margin-top: -0.01%;
    color: gray;
  }

  .avatar {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    border: 1px solid #fff;
    box-sizing: border-box;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(49, 49, 93, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.5s;

    &:hover {
      box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08),
        0px 2px 7px 0 rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
